export const LOYATY_ACCOUNT_DATA_EXPIRY = 30 * 60 * 1000;
export const LOYALTY_ACCOUNT_DATA = 'header_loyaltyAccountData';

export const LOYALTY_MODAL_AUTOSHOW_DELAY = 60 * 60 * 24 * 7 * 1000;
export const LOYALTY_MODAL_AUTOSHOW_DATA = 'header_loyaltyRegistrationModalShow';
